export default __webpack_public_path__ + "static/media/situation-coref-create-situation.287c6cc4.gif";